export const BUDGET_MONTHS = [
  { value: 1, label: 'January', short: 'Jan' },
  { value: 2, label: 'February', short: 'Feb' },
  { value: 3, label: 'March', short: 'Mar' },
  { value: 4, label: 'April', short: 'Apr' },
  { value: 5, label: 'May', short: 'May' },
  { value: 6, label: 'June', short: 'Jun' },
  { value: 7, label: 'July', short: 'Jul' },
  { value: 8, label: 'August', short: 'Aug' },
  { value: 9, label: 'September', short: 'Sep' },
  { value: 10, label: 'October', short: 'Oct' },
  { value: 11, label: 'November', short: 'Nov' },
  { value: 12, label: 'December', short: 'Dec' },
];

export const formatSpecificMonthsText = (months, t) => {
  if (!months || months.length === 0) return '';
  const monthsStr = months
    .map(m => {
      const match = BUDGET_MONTHS.find(x => x.value === m || x.value === Number(m));
      return match ? (t ? t(match.label) : match.label).substring(0, 3) : m;
    })
    .join(', ');
  const count = months.length;
  const unit = count === 1 ? (t ? t('month') : 'month') : (t ? t('months') : 'months');
  const inWord = t ? t('in') : 'in';
  return `(${inWord} ${monthsStr} - ${count} ${unit})`;
};
